import {cva} from "class-variance-authority";

export const tagBadgeStyles = cva('rounded-chip h-7 px-2 gap-1.5 text-footnote font-medium inline-flex items-center', {
    variants: {
        color: {
            indigo: 'bg-brand-tint-subtle text-brand-ink',
            zinc: 'bg-surface-muted text-ink-secondary',
            blue: 'bg-blue-100 text-blue-700',
            green: 'bg-green-100 text-green-700',
            orange: 'bg-orange-100 text-orange-700',
            purple: 'bg-purple-100 text-purple-700',
        }
    },
    defaultVariants: {
        color: 'indigo',
    },
});
